import { Grid, Typography, Paper, Box } from "@mui/material";
import strings from "./localization";

export function CharacterRibbon(character, actionButtons = null, extraSections = null) {
    return (
        <Paper variant="outlined" className="discreet-card" sx={{ p: 2, minHeight: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <Box>
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={8}>
                        <Box className="discreet-ribbon-row" sx={{ pb: 0.5 }}>
                            <Typography variant="h4" component="h1" sx={{ fontFamily: 'serif' }} noWrap>
                                {character.name}
                            </Typography>
                        </Box>
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', display: 'block', color: 'text.secondary' }}>
                            {strings.charactername || 'Character Name'}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Box className="discreet-ribbon-row" sx={{ pb: 0.5 }}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>{character.setting}</Typography>
                        </Box>
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', display: 'block', color: 'text.secondary' }}>
                            {strings.setting}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid item xs={6} sm={4}>
                        <Box className="discreet-ribbon-row" sx={{ pb: 0.5 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }} noWrap>{character.pcClass}</Typography>
                        </Box>
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', display: 'block', color: 'text.secondary' }}>{strings.class}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={3}>
                        <Box className="discreet-ribbon-row" sx={{ pb: 0.5 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }} noWrap>{character.race}</Typography>
                        </Box>
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', display: 'block', color: 'text.secondary' }}>{strings.race}</Typography>
                    </Grid>
                    <Grid item xs={2} sm={1}>
                        <Box className="discreet-ribbon-row" sx={{ pb: 0.5 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{character.lvl ?? 0}</Typography>
                        </Box>
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', display: 'block', color: 'text.secondary' }}>{strings.level}</Typography>
                    </Grid>
                    <Grid item xs={4} sm={2}>
                        <Box className="discreet-ribbon-row" sx={{ pb: 0.5 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{character.gold ?? 0} {strings.gp}</Typography>
                        </Box>
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', display: 'block', color: 'text.secondary' }}>{strings.gold}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <Box className="discreet-ribbon-row" sx={{ pb: 0.5 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{character.dt ?? 0} {strings.days}</Typography>
                        </Box>
                        <Typography variant="caption" sx={{ textTransform: 'uppercase', display: 'block', color: 'text.secondary' }}>{strings.downtime}</Typography>
                    </Grid>
                </Grid>
            </Box>
            {extraSections && (
                <Box sx={{ mt: 2 }}>
                    {extraSections}
                </Box>
            )}
            {actionButtons && (
                <Box className="discreet-ribbon-action" sx={{ mt: 2, pt: 2, display: 'flex', width: '100%' }}>
                    {actionButtons}
                </Box>
            )}
        </Paper>
    );
}
